import React, { FC, useEffect, useLayoutEffect } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ResolveThunks, connect } from "react-redux";
import Img from "@insite/mobius/Img";
import { getGaTagforL1L2 } from "@NA/Utils/GtmUtility";
import translate from "@insite/client-framework/Translate";
import { css } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { GridOffset } from "@insite/mobius/GridContainer";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
//import jQuery from "jquery";
export interface gaTaggingStyles {
    container: InjectableCss;
    containerCard: InjectableCss;
    textContent: InjectableCss;
    contentHeading:InjectableCss;
    contentPara:InjectableCss;
    contentLink:InjectableCss;
    containerImg:InjectableCss;

}
export const gaTaggingStyles: gaTaggingStyles = {
    container: {
        css: css`
            display:flex;
            
            >  ${GridOffset} {
                width:100%;
                padding:0px;
                margin:0px;
                display: flex;
                flex-flow: row;
                margin: 0px auto;
                padding: 0px;
                gap: 20px;
                background-color: rgb(255, 255, 255);
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css`flex-flow: column; `,], "max",);
                }}  
            }
        `,
    },
    containerCard: {
        css: css`
            position:relative;
            flex-basis: 50%;
            max-width: 50%;
            width: 50%;
            padding:0px;
            margin:0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css`width: 100%;max-width: 100%;flex-basis: 100%; `,], "max",);
            }}  
        `,

    },
    containerImg: {
        css: css`
        height:auto;
    `,
    },
    textContent: {
        css: css`
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        right: 0;
        background: rgba(0, 0, 0, .4);
        min-height: 135px;
        max-height: 140px;
        color: #fff;
        padding: 10px 30px 17px 30px;
        display: flex;
        flex-direction: column;
        ${({ theme }) => { return breakpointMediaQueries(
            theme, [null, css`  min-height: 95px;
            max-height: 95px; `,],"max",); 
        }}
        `,
    },
    contentHeading: {
        css: css`
        font-family: "Nunito Sans", sans-serif;
        font-size: 36px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        margin: 0;
        ${({ theme }) => { return breakpointMediaQueries(
            theme, [null, css` font-size: 24px; `,],"max",); 
        }}
        `,
    },
    contentPara: {
        css: css`
        font-family: "Nunito Sans", sans-serif;
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 15px 0;
        line-height: normal;
        color: #fff;
        ${({ theme }) => { return breakpointMediaQueries(
            theme, [null, css` font-size: 12px; margin: 0px 0 10px 0;`,],"max",); 
        }}
        `,
    },
    contentLink: {
        css: css`
        font-family: "Nunito Sans", sans-serif;
        font-size: 16px;
        font-weight: bold;
        text-transform: uppercase;
        ${({ theme }) => { return breakpointMediaQueries(
            theme, [null, css` font-size: 10px; `,],"max",); 
        }}
        `,
    },

    
}
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        session: state.context.session,
    };
};
const enum fields {
    left_Title="Webinars",
    left_subTitle="Learn about products, trending topics and more",
    left_Image_URL = "https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Category/Webinars.jpg",
    right_Title="Articles and Resources",
    right_subTitle="Discover our latest articles, guides and more",
    right_Image_URL = "https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Category/ArticlesandResources.jpg"
 }
type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapStateToProps>;

export const WebinarsL1 = ({ session }: Props) => {
    const displayPlaceHolderImageBasedOnAuth = () => {
        return (
            <GridContainer {...gaTaggingStyles.container}>
                    <GridItem {...gaTaggingStyles.containerCard}>
                        <Link  href="/webinars" data-ga-promo={getGaTagforL1L2(fields.left_Title, "", "")}>
                            <StyledWrapper>
                                <Img {...gaTaggingStyles.containerImg} src={fields.left_Image_URL}></Img>
                                <StyledWrapper {...gaTaggingStyles.textContent}>
                                    <Typography {...gaTaggingStyles.contentHeading}>{fields.left_Title}</Typography>
                                    <Typography {...gaTaggingStyles.contentPara}>{fields.left_subTitle}</Typography>
                                    <Typography {...gaTaggingStyles.contentLink}>{translate("LEARN MORE")}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        </Link>
                    </GridItem>                   
                    <GridItem {...gaTaggingStyles.containerCard}>
                        <Link  href="/articles-and-resources" data-ga-promo={getGaTagforL1L2(fields.right_Title, "", "")}>
                            <StyledWrapper>
                                <Img {...gaTaggingStyles.containerImg} alt="Articles and Resources" src={fields.right_Image_URL}></Img>
                                <StyledWrapper {...gaTaggingStyles.textContent}>
                                    <Typography {...gaTaggingStyles.contentHeading}>{fields.right_Title}</Typography>
                                    <Typography {...gaTaggingStyles.contentPara}>{fields.right_subTitle}</Typography>
                                    <Typography {...gaTaggingStyles.contentLink}>{translate("LEARN MORE")}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        </Link>
                    </GridItem>
            </GridContainer>
        );
    };

    return (
        <>
            {
                displayPlaceHolderImageBasedOnAuth()
            }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(WebinarsL1),
    definition: {
        group: "Common",
        displayName: "Webinars, Articles and Resources for L1",
        fieldDefinitions: [
            {
                name: "webinars_Image_URL",
                displayName: "webinars Image URL",
                editorTemplate: "TextField",
                defaultValue: fields.left_Image_URL,
                fieldType: "General",
                sortOrder: 0,
            },
            {
                name: "articlesResources_Image_URL",
                displayName: "ArticlesResources Image URL",
                editorTemplate: "TextField",
                defaultValue: fields.right_Image_URL,
                fieldType: "General",
                sortOrder: 0,
            },
           
        ],
    },
};

export default widgetModule;
